import React, { Component } from 'react'
import propTypes from 'prop-types'
import { observer } from 'mobx-react'

import Button from '@components/Button'
import Action from '@components/Action'
import PlusIcon from '@components/Icon/PlusIcon'
import DeleteIcon from '@components/Icon/Delete'

class RepeatableAction extends Component {
  static propTypes = {
    arrayHelpers: propTypes.object.isRequired,
    index: propTypes.number.isRequired,
    initialObject: propTypes.object.isRequired,
    disabled: propTypes.bool,
    allowAdd: propTypes.bool,
    allowDelete: propTypes.bool,
    fieldValues: propTypes.array,
    onAfterAdd: propTypes.func,
    onAfterDelete: propTypes.func
  }

  static defaultProps = {
    disabled: false,
    fieldValues: [],
    allowAdd: true,
    allowDelete: true
  }

  onAddAction = () => {
    this.props.arrayHelpers.push(this.props.initialObject)
    if (this.props.onAfterAdd) {
      this.props.onAfterAdd()
    }
  }

  onDeleteAction = () => {
    this.props.arrayHelpers.remove(this.props.index)
    if (this.props.onAfterDelete) {
      this.props.onAfterDelete()
    }
  }

  renderAddAction = () => {
    return (
      <Button
        className='expert-form__repeatable-action--add'
        small
        onClick={this.onAddAction}
        secondary
      >
        <PlusIcon blue />
      </Button>
    )
  }

  renderDeleteAction = () => {
    return (
      <Action
        className='expert-form__repeatable-action--delete'
        right
        onClick={this.onDeleteAction}
      >
        <DeleteIcon blue />
      </Action>
    )
  }

  render() {
    const { disabled, allowAdd, allowDelete, fieldValues } = this.props

    const renderAdd = allowAdd && fieldValues.length - 1 === this.props.index
    const renderDelete = allowDelete && fieldValues.length > 1

    return (
      <div>
        {renderAdd ? this.renderAddAction() : null}
        {renderDelete && !disabled ? this.renderDeleteAction() : null}
      </div>
    )
  }
}

export default observer(RepeatableAction)
